import React from 'react';
import TopPanel from "../toppanel.js";
import CheckListView from "../checklists/checklistview.js";
import MainReportView from "./MainReportView.js";
import PanelQR from "./PanelQR.js";
import ShareLink from "./ShareLink.js";
import ReportEdit from "./ReportEdit.js";


module.exports = React.createClass({
    success: function(reply) {
        this.commandCounter--;
        if (this.commandCounter < 0)
            this.commandCounter = 0;
        if (!this.mountState)
            return;
        if (!this.state.commandCounter) { // don't update model is there're other commands in queue
            HC_SetDataAndSelectedItem(this, reply.data);
        }
    },

    successChecklists: function(reply) {
        if (!this.mountState)
            return;
        this.setState({checklists: reply.data});
    },

    successAddReport: function(reply, action) {
        if (!this.mountState)
            return;
        this.state.selectedId = null;
        HC_SetDataAndSelectedItem(this, reply.data, {checkedItems:{}});
        this.goBack();
    },

    loadFromServer: function(id=null) {
        this.commandCounter++;
        HC_SendRequest("reports", null, this.success, null);
        HC_SendRequest("checklists", null, this.successChecklists, null);
    },

    getInitialState: function() {
        this.commandCounter = 0;
        return {
            data: [],
            selectedId: null,
            mode: HC_CONST.RM_VIEW,
            goBackEnabled: false,
            noData: true,
            selectMode: false,
            checklists: [],
            checkedItems: {},
            hideContent: false
        }
    },
    componentWillMount: function() {
        this.mountState = true;
        HC_CheckLoginAndAcc(this, HC_AccReports);
    },
    componentWillUnmount() {
        this.mountState = false;
    },
    componentDidMount: function() {
        HC_RestoreNavPanel();
        HC_SelectNavItem("li-reports");
        this.loadFromServer();
    },

    handleOnSelected: function(e, createNew=false) {
        this.goBack();
        if (HC_DeviceType() == HC_CONST.SCR_PHONE) {
            HC_SwitchRPanel(false);
        }
        this.setState({selectedId: e, isListSelected: false, hideContent: false});
    },

    handleOnDelete: function() {
        var report = HC_CurrentItem(this);
        if (report)
            return HC_Confirm(HC_LANG.REP_DEL_REP + ' "' + report.name + '"?', HC_LANG.CHL_DELETE, HC_LANG.DUE_CANCEL).then(function () {
                this.commandCounter++;
                this.state.data = [];
                this.state.selectedId = null;
                HC_SendRequest('delete_report', {id: parseInt(report.id)}, this.success);
                HC_CloseModal();
                this.goBack();
            }.bind(this));
    },

    getItemCaption: function(o) {
        return o.name;
    },

    getItemText: function(o) {
        var i = 0, period;
        if (!o.to_date) {
            if (o.days)
                period = HC_LANG.CHL_LATEST + " " + o.days + " " + HC_LANG.CHL_DAYS;
        } else {
            var dateTo = new Date(o.to_date);
            var dateFrom = new Date(dateTo.getTime() - o.days * 86400000);
            period = HC_FormatShortDate(dateFrom) + ' / ' + HC_FormatShortDate(dateTo);
        }
        var strings = [
            HC_LANG.REP_PERIOD + ": " + period,
            HC_LANG.REP_EXPIRIES + ": " + (o.expires ? HC_FormatShortDate(new Date(o.expires)) : HC_LANG.DUE_NEVER),
        ].map(function(s) {return (<div key={i++}>{s}</div>);});
        return <div>{strings}</div>;
    },

    handleShowQR: function() {
        this.setState({mode: HC_CONST.RM_QR});
    },

    handleShareLink: function() {
        this.setState({mode: HC_CONST.RM_LINK});
    },

    handleCreateReport: function() {
        this.setState({mode: HC_CONST.RM_CREATE, selectMode: true});
    },

    simpleResetNew: function() {
        this.setState({mode: HC_CONST.RM_VIEW, checkedItems:{}});
    },

    checkChanged: function(checkedItems) {
        this.setState({checkedItems: checkedItems});
    },

    onCreateReport: function(newReport) {
        HC_SendRequest('add_report', newReport,
            function(r) { this.successAddReport(r); }.bind(this)
        );
    },


    goBack: function() {
        switch (this.state.mode) {
            case HC_CONST.RM_VIEW:
                this.setState({mode: HC_CONST.RM_VIEW, isListSelected: true, hideContent: (HC_DeviceType() === HC_CONST.SCR_PHONE)});
                HC_RestoreRPanel();
                break;
            case HC_CONST.RM_QR:
                this.setState({mode: HC_CONST.RM_VIEW});
                break;
            case HC_CONST.RM_LINK:
                this.setState({mode: HC_CONST.RM_VIEW});
                break;
            case HC_CONST.RM_CREATE:
                this.setState({selectMode: false, checkedItems:{}});
                HC_RestoreRPanel();
                this.setState({mode: HC_CONST.RM_VIEW});
                break;
        }
    },

    render: function() {
        var ricon = HC_AccReports() || HC_AccAdmin() ? "fa-plus-circle" : "";
        var riconClick = this.handleCreateReport;
        var licon = "fa-bars";
        var liconClick = HC_ToggleNavPanel;
        var text = HC_LANG.REP_CAPTION;

        var content, listView;
        switch (this.state.mode) {
            case HC_CONST.RM_VIEW:
                content = (
                    <MainReportView data={this.state.data} selectedId={this.state.selectedId} onGoBack={this.goBack}
                                    onDelete={this.handleOnDelete} onShowQR={this.handleShowQR} onShareLink={this.handleShareLink}
                                    phoneSelected={!this.state.isListSelected} hideContent={this.state.hideContent}
                    />);
                break;
            case HC_CONST.RM_QR:
                content = (
                    <PanelQR data={this.state.data} selectedId={this.state.selectedId} onGoBack={this.goBack}
                             phoneSelected={!this.state.isListSelected}/>);
                break;
            case HC_CONST.RM_LINK:
                content = (
                    <ShareLink data={this.state.data} selectedId={this.state.selectedId} onGoBack={this.goBack}
                             phoneSelected={!this.state.isListSelected}/>);
                break;
            case HC_CONST.RM_CREATE:
                var checkedIds = Object.keys(this.state.checkedItems).filter(function(k){return this.state.checkedItems[k];}.bind(this))

                licon = ricon = liconClick = riconClick = null;
                var deviceType = HC_DeviceType();
                text = HC_LANG.REP_CHOOSE_LIST;
                if (deviceType === HC_CONST.SCR_PHONE) {
                    licon = "fa-angle-left";
                    liconClick = this.simpleResetNew;
                    ricon = "fa-check-circle";
                    riconClick = function(){HC_SwitchRPanel();};

                    if (checkedIds.length === 0) {
                        ricon += ' hc-fa-action-disabled';
                        riconClick = undefined;
                    }

                }
                if (deviceType === HC_CONST.SCR_DESCKTOP) {
                    text += ' for report';
                }
                listView = (<CheckListView data={this.state.checklists} getCaption={function(o){return o.name;}} getText={HC_GetChecklistText}
                                           onCheck={this.handleOnSelectChecklist} multiSelect={true} checkedItems={this.state.checkedItems} checkChanged={this.checkChanged}/>);
                content = (
                    <ReportEdit checklists={this.state.checklists} onGoBack={this.goBack} checkedIds={checkedIds}
                               phoneSelected={!this.state.isListSelected} onCreateReport={this.onCreateReport}/>);
                break;
        }

        if (!listView)
            listView = (<CheckListView data={this.state.data} getCaption={this.getItemCaption} getText={this.getItemText} selectedId={this.state.selectedId} onSelect={this.handleOnSelected} showSearch={true}/>);

        return (
            <div style={{height:"100%"}}>
                <div className="hc-list-panel hc-br">
                    <TopPanel text={text} licon={licon} ricon={ricon} onLiconClick={liconClick}
                              onRiconClick={riconClick}/>
                    <div>
                        {listView}
                    </div>
                </div>
                <div className="hc-content-panel">
                    {content}
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./reports/ReportsPanel.js